import { useForm } from "../../context/waitlist-context";
import {
  BALANCE_TRANSFER,
  BANK_NAMES,
  BUSINESS_NATURE_OPTIONS,
  COMPANY_TYPE,
  EMPLOYMENT_TYPE,
  INDUSTRY_TYPE,
} from "../constant";
import {
  CustomDateInput,
  CustomDropdown,
  CustomInput,
} from "./input-component";
import { usePostLoanDataMutation } from "../../../../store/api/moneyApi";

type PersonalLoanData = {
  desired_amount: number;
  employment_type: string;
  monthly_income: number;
  employment_duration: number;
  bank_account: string;
  total_ongoing_emi: number;
};

type BusinessLoanData = {
  desired_amount: number;
  annual_gross_turnover: number;
  business_vintage: string;
  company_type: string;
  industry: string;
  business_nature: string;
  profit_after_tax: number;
  bank_account: string;
  total_ongoing_emi: number;
};

type HomeLoanData = {
  desired_amount: number;
  employment_type: string;
  monthly_income: number;
  employment_duration: number;
  bank_account: string;
  total_ongoing_emi: number;
};

type BalanceTransferData = {
  desired_amount: number;
  balance_transfer: string;
  employment_type: string;
  annual_gross_turnover: number;
  employment_duration: number;
  outstanding_principal: number;
  interest_rate: number;
  total_loan_tenure: number;
  bank_account: string;
};

type StudentLoanData = {
  desired_amount: number;
  student_name: string;
  father_employment_type: string;
  father_monthly_income: number;
  mother_employment_type: string;
  mother_monthly_income: number;
  bank_account: string;
  total_ongoing_emi: number;
  country: string;
  course_start_date: string;
  course_duration: number;
  course_name: string;
};

type LoanFormData = {
  first_name: string;
  last_name: string;
  phone: string;
  gender: string;
  isd: string;
  dob: string;
  pan: string;
  email: string;
  residence_type: string;
  pincode: number;
  city: string;
  state: string;
  loan_type: string;
  personal?: PersonalLoanData;
  business?: BusinessLoanData;
  home?: HomeLoanData;
  balance?: BalanceTransferData;
  student?: StudentLoanData;
};

export function FinancialProfile() {
  const { formData, updateFormData, prevStep, nextStep } = useForm();
  const [triggerPostLoanData] = usePostLoanDataMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const data = {
      // first_name: formData.personalDetails.firstName,
      // last_name: formData.personalDetails.lastName,
      // phone: formData.personalDetails.phoneNumber.slice(2),
      // gender: formData.personalDetails.gender,
      // isd: formData.personalDetails.phoneNumber.slice(0,2) || "+91",
      // dob: formData.personalDetails.dateOfBirth,
      pan: formData.personalDetails.panCard,
      // email: formData.personalDetails.email,
      residence_type: formData.personalDetails.residenceType,
      pincode: Number(formData.personalDetails.pincode),
      city: formData.personalDetails.city,
      state: formData.personalDetails.state,
      loan_type: formData.form.type,
    } as LoanFormData;
    if (formData.form.type === "personal") {
      data.personal = {
        desired_amount: Number(formData.personalLoan.desiredLoanAmount),
        employment_type: formData.personalLoan.employmentType,
        monthly_income: Number(formData.personalLoan.monthlyIncome),
        employment_duration: Number(formData.personalLoan.yearsEmployed),
        bank_account: formData.personalLoan.primaryBank,
        total_ongoing_emi: Number(formData.personalLoan.totalEmi),
      };
    }
    if (formData.form.type === "business") {
      data.business = {
        desired_amount: Number(formData.businessLoan.desiredLoanAmount),
        annual_gross_turnover: Number(
          formData.businessLoan.annualGrossTurnover,
        ),
        business_vintage: formData.businessLoan.businessVintage,
        company_type: formData.businessLoan.companyType,
        industry: formData.businessLoan.industryType,
        business_nature: formData.businessLoan.natureOfBusiness,
        profit_after_tax: Number(formData.businessLoan.profitAfterTax),
        bank_account: formData.businessLoan.primaryBank,
        total_ongoing_emi: Number(formData.businessLoan.totalEmi),
      };
    }
    if (formData.form.type === "home") {
      data.home = {
        desired_amount: Number(formData.homeLoan.desiredLoanAmount),
        employment_type: formData.homeLoan.employmentType,
        monthly_income: Number(formData.homeLoan.monthlyIncome),
        employment_duration: Number(formData.homeLoan.yearsEmployed),
        bank_account: formData.homeLoan.primaryBank,
        total_ongoing_emi: Number(formData.homeLoan.totalEmi),
      };
    }
    if (formData.form.type === "balance_transfer") {
      data.balance = {
        desired_amount: Number(formData.balanceTransfer.desiredLoanAmount),
        balance_transfer: formData.balanceTransfer.balanceTransferType,
        employment_type: formData.balanceTransfer.profession,
        annual_gross_turnover: Number(formData.balanceTransfer.totalCTC),
        employment_duration: Number(formData.balanceTransfer.totalYears),
        outstanding_principal: Number(
          formData.balanceTransfer.outstandingPrincipal,
        ),
        interest_rate: Number(formData.balanceTransfer.presentInterestRate),
        total_loan_tenure: Number(formData.balanceTransfer.remainingTenure),
        bank_account: formData.balanceTransfer.bankAccount,
      };
    }
    if (formData.form.type === "student") {
      data.student = {
        desired_amount: Number(formData.studentLoan.desiredLoanAmount),
        student_name: formData.studentLoan.studentFullName,
        father_employment_type: formData.studentLoan.fatherEmploymentType,
        father_monthly_income: Number(formData.studentLoan.fatherMonthlyIncome),
        mother_employment_type: formData.studentLoan.motherEmploymentType,
        mother_monthly_income: Number(formData.studentLoan.motherMonthlyIncome),
        bank_account: formData.studentLoan.primaryBank,
        total_ongoing_emi: Number(formData.studentLoan.totalEmi),
        country: formData.studentLoan.countryOfStudy,
        course_start_date: formData.studentLoan.courseStartDate,
        course_duration: Number(formData.studentLoan.courseDuration),
        course_name: formData.studentLoan.courseName,
      };
    }

    console.log(data);

    try {
      const resp = await triggerPostLoanData(data);
      if (resp.data.success) nextStep();
      else prevStep();
    } catch (error) {
      console.error(error);
      prevStep();
    }
  };

  function getFormFields() {
    switch (formData.form.type) {
      case "personal":
        return (
          <>
            <CustomInput
              type="number"
              label="What's your desired loan amount?"
              value={formData.personalLoan.desiredLoanAmount}
              onChange={(name, value) =>
                updateFormData("personalLoan", {
                  ...formData.personalLoan,
                  [name]: value,
                })
              }
              placeholder="What's your desired loan amount?"
              name="desiredLoanAmount"
            />
            <CustomDropdown
              label="What's your employment type?"
              placeholder="What's your employment type?"
              options={EMPLOYMENT_TYPE}
              value={formData.personalLoan.employmentType}
              onChange={(name, value) =>
                updateFormData("personalLoan", {
                  ...formData.personalLoan,
                  [name]: value,
                })
              }
              name="employmentType"
            />
            <CustomInput
              type="number"
              label="What's your monthly income?"
              value={formData.personalLoan.monthlyIncome}
              onChange={(name, value) =>
                updateFormData("personalLoan", {
                  ...formData.personalLoan,
                  [name]: value,
                })
              }
              placeholder="What's your monthly income?"
              name="monthlyIncome"
            />
            <CustomInput
              type="number"
              label="How many years have you been employed?"
              value={formData.personalLoan.yearsEmployed}
              onChange={(name, value) =>
                updateFormData("personalLoan", {
                  ...formData.personalLoan,
                  [name]: value,
                })
              }
              placeholder="How many years have you been employed?"
              name="yearsEmployed"
            />

            <CustomDropdown
              label="Which is your primary bank?"
              options={BANK_NAMES}
              value={formData.personalLoan.primaryBank}
              onChange={(name, value) =>
                updateFormData("personalLoan", {
                  ...formData.personalLoan,
                  [name]: value,
                })
              }
              name="primaryBank"
            />
            <CustomInput
              type="number"
              label="What's your total EMI outflow?"
              value={formData.personalLoan.totalEmi}
              onChange={(name, value) =>
                updateFormData("personalLoan", {
                  ...formData.personalLoan,
                  [name]: value,
                })
              }
              placeholder="What's your total EMI outflow?"
              name="totalEmi"
            />
          </>
        );
      case "business":
        return (
          <>
            <CustomInput
              type="number"
              label="What's your desired loan amount?"
              value={formData.businessLoan.desiredLoanAmount}
              onChange={(name, value) =>
                updateFormData("businessLoan", {
                  ...formData.businessLoan,
                  [name]: value,
                })
              }
              placeholder="What's your desired loan amount?"
              name="desiredLoanAmount"
            />
            <CustomInput
              type="number"
              label="What's your annual gross turnover?"
              value={formData.businessLoan.annualGrossTurnover}
              onChange={(name, value) =>
                updateFormData("businessLoan", {
                  ...formData.businessLoan,
                  [name]: value,
                })
              }
              placeholder="What's your annual gross turnover?"
              name="annualGrossTurnover"
            />
            <CustomInput
              type="number"
              label="How many years has your business been operational?"
              value={formData.businessLoan.businessVintage}
              onChange={(name, value) =>
                updateFormData("businessLoan", {
                  ...formData.businessLoan,
                  [name]: value,
                })
              }
              placeholder="How many years has your business been operational?"
              name="businessVintage"
            />
            <CustomDropdown
              placeholder="What's your company type?"
              label="What's your company type?"
              options={COMPANY_TYPE}
              value={formData.businessLoan.companyType}
              onChange={(name, value) =>
                updateFormData("businessLoan", {
                  ...formData.businessLoan,
                  [name]: value,
                })
              }
              name="companyType"
            />
            <CustomDropdown
              placeholder="What's your industry type?"
              label="What's your industry type?"
              options={INDUSTRY_TYPE}
              value={formData.businessLoan.industryType}
              onChange={(name, value) =>
                updateFormData("businessLoan", {
                  ...formData.businessLoan,
                  [name]: value,
                })
              }
              name="industryType"
            />
            <CustomDropdown
              placeholder="What's the nature of your business?"
              label="What's the nature of your business?"
              options={BUSINESS_NATURE_OPTIONS}
              value={formData.businessLoan.natureOfBusiness}
              onChange={(name, value) =>
                updateFormData("businessLoan", {
                  ...formData.businessLoan,
                  [name]: value,
                })
              }
              name="natureOfBusiness"
            />
            <CustomInput
              type="number"
              label="What's your profit after tax?"
              value={formData.businessLoan.profitAfterTax}
              onChange={(name, value) =>
                updateFormData("businessLoan", {
                  ...formData.businessLoan,
                  [name]: value,
                })
              }
              placeholder="What's your profit after tax?"
              name="profitAfterTax"
            />
            <CustomDropdown
              placeholder="Which is your primary bank?"
              label="Which is your primary bank?"
              options={BANK_NAMES}
              value={formData.businessLoan.primaryBank}
              onChange={(name, value) =>
                updateFormData("businessLoan", {
                  ...formData.businessLoan,
                  [name]: value,
                })
              }
              name="primaryBank"
            />
            <CustomInput
              type="number"
              label="What's your total EMI outflow?"
              value={formData.businessLoan.totalEmi}
              onChange={(name, value) =>
                updateFormData("businessLoan", {
                  ...formData.businessLoan,
                  [name]: value,
                })
              }
              placeholder="What's your total EMI outflow?"
              name="totalEmi"
            />
          </>
        );
      case "home":
        return (
          <>
            <CustomInput
              type="number"
              label="What's your desired loan amount?"
              value={formData.homeLoan.desiredLoanAmount}
              onChange={(name, value) =>
                updateFormData("homeLoan", {
                  ...formData.homeLoan,
                  [name]: value,
                })
              }
              placeholder="What's your desired loan amount?"
              name="desiredLoanAmount"
            />

            <CustomDropdown
              label="What's your employment type?"
              options={EMPLOYMENT_TYPE}
              value={formData.homeLoan.employmentType}
              onChange={(name, value) =>
                updateFormData("homeLoan", {
                  ...formData.homeLoan,
                  [name]: value,
                })
              }
              name="employmentType"
            />
            <CustomInput
              type="number"
              label="What's your monthly income?"
              value={formData.homeLoan.monthlyIncome}
              onChange={(name, value) =>
                updateFormData("homeLoan", {
                  ...formData.homeLoan,
                  [name]: value,
                })
              }
              placeholder="What's your monthly income?"
              name="monthlyIncome"
            />
            <CustomInput
              type="number"
              label="How many years have you been employed?"
              value={formData.homeLoan.yearsEmployed}
              onChange={(name, value) =>
                updateFormData("homeLoan", {
                  ...formData.homeLoan,
                  [name]: value,
                })
              }
              placeholder="How many years have you been employed?"
              name="yearsEmployed"
            />
            <CustomDropdown
              label="Which is your primary bank?"
              options={BANK_NAMES}
              value={formData.homeLoan.primaryBank}
              onChange={(name, value) =>
                updateFormData("homeLoan", {
                  ...formData.homeLoan,
                  [name]: value,
                })
              }
              name="primaryBank"
            />
            <CustomInput
              type="number"
              label="What's your total EMI outflow?"
              value={formData.homeLoan.totalEmi}
              onChange={(name, value) =>
                updateFormData("homeLoan", {
                  ...formData.homeLoan,
                  [name]: value,
                })
              }
              placeholder="What's your total EMI outflow?"
              name="totalEmi"
            />
          </>
        );

      case "balance_transfer":
        return (
          <>
            <CustomDropdown
              label="What's your balance transfer type?"
              options={BALANCE_TRANSFER}
              value={formData.balanceTransfer.balanceTransferType}
              onChange={(name, value) =>
                updateFormData("balanceTransfer", {
                  ...formData.balanceTransfer,
                  [name]: value,
                })
              }
              name="balanceTransferType"
            />
            <CustomInput
              type="number"
              label="What's your desired loan amount?"
              value={formData.balanceTransfer.desiredLoanAmount}
              onChange={(name, value) =>
                updateFormData("balanceTransfer", {
                  ...formData.balanceTransfer,
                  [name]: value,
                })
              }
              placeholder="What's your desired loan amount?"
              name="desiredLoanAmount"
            />
            <CustomDropdown
              label="What's your profession?"
              options={EMPLOYMENT_TYPE}
              value={formData.balanceTransfer.profession}
              onChange={(name, value) =>
                updateFormData("balanceTransfer", {
                  ...formData.balanceTransfer,
                  [name]: value,
                })
              }
              name="profession"
            />
            <CustomInput
              type="number"
              label="What's your total CTC?"
              value={formData.balanceTransfer.totalCTC}
              onChange={(name, value) =>
                updateFormData("balanceTransfer", {
                  ...formData.balanceTransfer,
                  [name]: value,
                })
              }
              placeholder="What's your total CTC?"
              name="totalCTC"
            />
            <CustomInput
              type="number"
              label="How many years have you been employed?"
              value={formData.balanceTransfer.totalYears}
              onChange={(name, value) =>
                updateFormData("balanceTransfer", {
                  ...formData.balanceTransfer,
                  [name]: value,
                })
              }
              placeholder="How many years have you been employed?"
              name="totalYears"
            />
            <CustomInput
              type="number"
              label="What's your outstanding principal?"
              value={formData.balanceTransfer.outstandingPrincipal}
              onChange={(name, value) =>
                updateFormData("balanceTransfer", {
                  ...formData.balanceTransfer,
                  [name]: value,
                })
              }
              placeholder="What's your outstanding principal?"
              name="outstandingPrincipal"
            />
            <CustomInput
              type="number"
              label="What's your present interest rate?"
              value={formData.balanceTransfer.presentInterestRate}
              onChange={(name, value) =>
                updateFormData("balanceTransfer", {
                  ...formData.balanceTransfer,
                  [name]: value,
                })
              }
              placeholder="What's your present interest rate?"
              name="presentInterestRate"
            />
            <CustomInput
              type="number"
              label="What's your remaining tenure?"
              value={formData.balanceTransfer.remainingTenure}
              onChange={(name, value) =>
                updateFormData("balanceTransfer", {
                  ...formData.balanceTransfer,
                  [name]: value,
                })
              }
              placeholder="What's your remaining tenure?"
              name="remainingTenure"
            />
            <CustomDropdown
              label="Which is your primary bank?"
              options={BANK_NAMES}
              value={formData.balanceTransfer.bankAccount}
              onChange={(name, value) =>
                updateFormData("balanceTransfer", {
                  ...formData.balanceTransfer,
                  [name]: value,
                })
              }
              name="bankAccount"
            />
          </>
        );
      case "student":
        return (
          <>
            <CustomInput
              type="number"
              label="What's your desired loan amount?"
              value={formData.studentLoan.desiredLoanAmount}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              placeholder="What's your desired loan amount?"
              name="desiredLoanAmount"
            />
            <CustomDropdown
              label="What's your father's employment type?"
              options={EMPLOYMENT_TYPE}
              value={formData.studentLoan.fatherEmploymentType}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              name="fatherEmploymentType"
            />
            <CustomInput
              type="number"
              label="What's your father's monthly income?"
              value={formData.studentLoan.fatherMonthlyIncome}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              placeholder="What's your father's monthly income?"
              name="fatherMonthlyIncome"
            />
            <CustomDropdown
              label="What's your mother's employment type?"
              options={EMPLOYMENT_TYPE}
              value={formData.studentLoan.motherEmploymentType}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  // ...formData.form,
                  // studentLoan: {
                  ...formData.studentLoan,
                  [name]: value,
                  // },
                })
              }
              name="motherEmploymentType"
            />
            <CustomInput
              type="number"
              label="What's your mother's monthly income?"
              value={formData.studentLoan.motherMonthlyIncome}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              placeholder="What's your mother's monthly income?"
              name="motherMonthlyIncome"
            />
            <CustomDropdown
              label="Which is your primary bank?"
              options={BANK_NAMES}
              value={formData.studentLoan.primaryBank}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              name="primaryBank"
            />
            <CustomInput
              type="number"
              label="What's your total EMI outflow?"
              value={formData.studentLoan.totalEmi}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              placeholder="What's your total EMI outflow?"
              name="totalEmi"
            />
            <CustomInput
              type="text"
              label="What's your full name?"
              value={formData.studentLoan.studentFullName}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              placeholder="What's your full name?"
              name="studentFullName"
            />
            <CustomInput
              type="text"
              label="Where are you studying?"
              value={formData.studentLoan.countryOfStudy}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              placeholder="Where are you studying?"
              name="countryOfStudy"
            />
            <CustomDateInput
              placeholder="When does your course start?"
              label="When does your course start?"
              value={formData.studentLoan.courseStartDate}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              name="courseStartDate"
            />
            <CustomInput
              type="number"
              label="What's the duration of your course?"
              value={formData.studentLoan.courseDuration}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              placeholder="What's the duration of your course?"
              name="courseDuration"
            />
            <CustomInput
              type="text"
              label="What's the name of your course?"
              value={formData.studentLoan.courseName}
              onChange={(name, value) =>
                updateFormData("studentLoan", {
                  ...formData.studentLoan,
                  [name]: value,
                })
              }
              placeholder="What's the name of your course?"
              name="courseName"
            />
          </>
        );
      default:
        return <></>;
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-6 h-full flex flex-col overflow-y-scroll"
    >
      {getFormFields()}
      <div className="flex justify-between pt-4 h-fit">
        <button
          type="button"
          onClick={() => prevStep()}
          className="py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Back
        </button>
        <button
          type="submit"
          className="py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white bg-[#007aff]"
        >
          Submit
        </button>
      </div>
    </form>
  );
}
